import {} from '@mui/material'

// material-ui

// project imports
import ViewProfileListComponent from 'features/view/profile/list/component/view-profile-list-component'

// ==============================|| PROFILE 3 ||============================== //

// styles
const Profile3 = () => {
  return (
    <>
      <ViewProfileListComponent />
    </>
  )
}

export default Profile3
